// 留言確認彈窗

const NewsCommentConfirm = ({ onComment, t, setShowConfirm }) => {
    return (
        <div className="modal">
            <div className="w-[422px] rounded-[12px] p-[40px] text-center bg-black usm:px-[30px] shadow-[0px_0px_20px_0px_rgba(135,135,135,.25)]">
                <p className="text-h5 text-white">{t('CONFIRM_TITLE')}</p>

                <pre className="mt-[14px] mb-[28px] text-center text-bd1m text-black1 whitespace-pre-wrap">
                    {t('CONFIRM_CONTENT')}
                </pre>

                {/* 送出按鈕 */}
                <button
                    className="text-white block w-[240px] py-[16px] bg-bou trans text-center mx-auto text-btn1 rounded-[40px] hover:bg-purple"
                    onClick={onComment}
                >
                    {t('SUBMIT')}
                </button>
            </div>

            <div className="close-bg" onClick={() => setShowConfirm(false)} />
        </div>
    );
};

export default NewsCommentConfirm;
